type IconName =
  | "all"
  | "calendar"
  | "check"
  | "chevron-down"
  | "chevron-up"
  | "close"
  | "edit"
  | "inbox"
  | "menu"
  | "moon"
  | "more"
  | "plus"
  | "search"
  | "sun"
  | "today"
  | "trash";

export function Icon(props: { name: IconName; size?: number }) {
  const size = props.size ?? 18;
  return (
    <svg
      class="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      {pathFor(props.name)}
    </svg>
  );
}

function pathFor(name: IconName) {
  if (name === "plus") return <><path d="M12 5v14" /><path d="M5 12h14" /></>;
  if (name === "menu") return <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>;
  if (name === "close") return <><path d="m6 6 12 12" /><path d="m18 6-12 12" /></>;
  if (name === "search") return <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>;
  if (name === "today") return <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /><path d="M9 15h6" /></>;
  if (name === "calendar") return <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></>;
  if (name === "all") return <><path d="M8 6h13M8 12h13M8 18h13" /><path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></>;
  if (name === "check") return <><circle cx="12" cy="12" r="9" /><path d="m8 12 2.5 2.5L16 9" /></>;
  if (name === "inbox") return <><path d="M4 5h16l1 10H15l-2 3h-2l-2-3H3L4 5Z" /><path d="M4 11h5l2 3h2l2-3h5" /></>;
  if (name === "edit") return <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" /></>;
  if (name === "trash") return <><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v5M14 11v5" /></>;
  if (name === "chevron-up") return <path d="m6 15 6-6 6 6" />;
  if (name === "chevron-down") return <path d="m6 9 6 6 6-6" />;
  if (name === "moon") return <path d="M20 15.5A8.5 8.5 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5Z" />;
  if (name === "sun") return <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42" /></>;
  return <><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" /></>;
}
